import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-five-minute-crafts',
  templateUrl: './five-minute-crafts.component.html',
  styleUrls: ['./five-minute-crafts.component.css']
})
export class FiveMinuteCraftsComponent implements OnInit {
  videoId: string = "-AbNcFMro4o";

  constructor() { }

  ngOnInit(): void {
  }

}
